import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=3f3a92b8&"
import script from "./BranchEdit.vue?vue&type=script&lang=js&"
export * from "./BranchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports